<script>
    import { createEventDispatcher } from "svelte";
    const dispatch = createEventDispatcher();

    import WeekContainer from "./WeekContainer.svelte";
    import HeaderIntro from "../basic/HeaderIntro.svelte";

    export let orderFrame;
    export let milkTypeOfSchool;
    export let userSelectionOrder;
</script>

<HeaderIntro mainText={"Milchbestellung"} subText={"Wähle hier deine Milch für den aktuellen Lieferzeitraum aus."}/>

<div class="row weekContainerContainer">
    {#each orderFrame.weekSlices as week}
        <WeekContainer {week} userSelectionOrderWeek={userSelectionOrder.weekSlices[week.weekNo]} {milkTypeOfSchool} on:newSelection/>
    {/each}
</div>


<style>
    .weekContainerContainer {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: stretch;
    }
</style>